import assignWarehousesToVendorConfig from './assignWarehousesToVendorConfig';
import createPo from './createPo';
import customPurchaseOrderOverview from './customPurchaseOrderOverview';

import activeCycleCountPage from './cycleCount/activeCycleCountPage';
import historicalCycleCountPage from './cycleCount/historicalCycleCountPage';
import lostAndFoundPage from './cycleCount/lostAndFoundPage';
import lostAndFoundTab from './cycleCount/lostAndFoundTab';
import managerReviewPage from './cycleCount/managerReviewPage';
import waveDetailsPage from './cycleCount/waveDetailsPage';

import integrationsConfig from './integrationsConfig';
import interOffice from './interOffice';
import smartlookConfig from './smartlookConfig';
import shippingPrintLabel from './shippingPrintLabel';
import nikeOrderDecisionRules from './nikeOrderDecisionRules';
import productBarcodeGridPage from './product/productBarcodeGridPage';
import productDetailsPage from './product/productDetailsPage';
import productDetailsStockPage from './product/productDetailsStockPage';
import productsGridPage from './product/productsGridPage';

import fulfillmentAllShipmentGridPage from './fulfillments/ship/fulfillmentAllShipmentGridPage'

import customGeneral from './customGeneral';
import skuFilterInFulfillments from './skuFilterInFulfillments';
import shippingManifest from './shippingManifest';
import oktaLogin from './oktaLogin';

import userChangePasswordPage from './users/userChangePasswordPage';
import userDetailsPage from './users/userDetailsPage';
import userFormPage from './users/userFormPage';
import userGridPage from './users/userGridPage';
import userProfilePage from './users/userProfilePage';
import userProductivityReportPage from './users/userProductivityReportPage';

import shipFulfillmentGroupPickingPage from './fulfillments/ship/fulfillmentGroupPickingPage';
import shipFulfillmentPackingPage from './fulfillments/ship/fulfillmentPackingPage';
import shipFulfillmentPickingPage from './fulfillments/ship/fulfillmentPickingPage';

import pickupFulfillmentGroupPickingPage from './fulfillments/pickup/fulfillmentGroupPickingPage';
import pickupFulfillmentPickingPage from './fulfillments/pickup/fulfillmentPickingPage';

import putAwayPage from './receiveInventory/putAwayPage';

import warehouseFormPage from './warehouse/warehouseFormPage';
import warehouseGridPage from './warehouse/warehouseGridPage';
import warehouseLocationsPage from './warehouse/warehouseLocationsPage';
import warehouseLocationsWithProductsPage from './warehouse/warehouseLocationsWithProductsPage';
import assignVendorsToWarehousePage from './warehouse/assignVendorsToWarehousePage';


export default {
    assignWarehousesToVendorConfig,
    createPo,
    activeCycleCountPage,
    historicalCycleCountPage,
    lostAndFoundPage,
    lostAndFoundTab,
    managerReviewPage,
    waveDetailsPage,
    integrationsConfig,
    customPurchaseOrderOverview,
    interOffice,
    nikeOrderDecisionRules,
    productBarcodeGridPage,
    productDetailsStockPage,
    productDetailsPage,
    productsGridPage,
    smartlookConfig,
    shippingPrintLabel,
    customGeneral,
    skuFilterInFulfillments,
    shipFulfillmentGroupPickingPage,
    shipFulfillmentPackingPage,
    shipFulfillmentPickingPage,
    pickupFulfillmentGroupPickingPage,
    pickupFulfillmentPickingPage,
    shippingManifest,
    oktaLogin,
    userChangePasswordPage,
    userDetailsPage,
    userFormPage,
    userGridPage,
    userProfilePage,
    userProductivityReportPage,
    fulfillmentAllShipmentGridPage,
    putAwayPage,
    warehouseFormPage,
    warehouseGridPage,
    warehouseLocationsPage,
    warehouseLocationsWithProductsPage,
    assignVendorsToWarehousePage,
};
